import { useDispatch, useSelector } from 'react-redux';
import { AnyAction, ThunkDispatch, unwrapResult } from '@reduxjs/toolkit';

import { GlobalState } from '@modules/createStore';
import { filtersSelectors, filtersActions } from '@modules/filters';

type AppDispatch = ThunkDispatch<GlobalState, any, AnyAction>;

export const useFilters = () => {
  const dispatch: AppDispatch = useDispatch();

  const filterOptions = useSelector(filtersSelectors.selectFilterOptions);
  const fetchFilterOptions = () => dispatch(filtersActions.fetchFilterOptions()).then(unwrapResult);

  return { filterOptions, fetchFilterOptions };
};
